import React, { useEffect } from "react";

import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";

import { useDispatch, useSelector } from "react-redux";
import { Box, Typography } from "@material-ui/core";
import TestsRequests from "services/tests";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import QuizTicketListTableHeading from "./QuizTicketListTableHeading";
import QuizTicketListTableItem from "./QuizTicketListTableItem";

const QuizTicketListTable = ({ searchMode, searchInput }) => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const { quizTicketList } = useSelector(({ tests }) => tests);

  useEffect(() => {
    dispatch(TestsRequests.getQuizTicketListByID(id, searchInput));
  }, [searchMode, searchInput]);

  return (
    <div className="Cmt-table-responsive">
      {quizTicketList &&
        (quizTicketList.length === 0 ? (
          <Box
            display={"flex"}
            justifyContent={"center"}
            paddingTop={"30px"}
            paddingBottom={"20px"}
          >
            <Typography variant="h3">موردی برای نمایش وجود ندارد</Typography>
          </Box>
        ) : (
          <Table>
            <TableHead>
              <QuizTicketListTableHeading />
            </TableHead>
            <TableBody>
              {quizTicketList.map((item) => (
                <QuizTicketListTableItem
                  user={item.owner}
                  key={item._id}
                  id={item._id}
                  quizId={id}
                />
              ))}
            </TableBody>
          </Table>
        ))}
    </div>
  );
};

export default QuizTicketListTable;
